import { useSearchParams } from "#routers/hooks";
import { CalculatorsEmissionsTab } from "#routes/calculations/calculators/CalculatorsEmissionsTab";
import { CalculatorsNetworkTab } from "#routes/calculations/calculators/CalculatorsNetworkTab";
import { CalculatorsVolumeTab } from "#routes/calculations/calculators/CalculatorsVolumeTab";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { CalculatorsListRoutePath } from "#src/routes/calculations/calculators";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page, Tab } from "@validereinc/common-components";
import { toTitleCaseString } from "@validereinc/utilities";
import React from "react";
import { CalculatorsTab } from ".";

export const CalculatorsPage = () => {
  const [breadcrumbs] = useBreadcrumbsFromRoute(CalculatorsListRoutePath);
  const [{ tab }, setSearchParams] = useSearchParams();

  const [isFlowVolumeEnabled, isLoadingFlowVolumeEnabled] =
    useIsFeatureAvailable({
      featureFlagQuery: {
        $and: ["core:flows", "core:volumetric_estimation_methods"],
      },
      permissionQuery: { $and: ["flows:read", "records:read"] },
    });
  const [isNetworkProrationEnabled, isLoadingNetworkProrationEnabled] =
    useIsFeatureAvailable({
      featureFlagQuery: "core:networks",
      permissionQuery: "networks:read",
    });
  const [isEquipmentEmissionsEnabled, isLoadingEquipmentEmissionsEnabled] =
    useIsFeatureAvailable({
      featureFlagQuery: "core:equipment",
      permissionQuery: { $and: ["equipment:read", "calculator_results:read"] },
    });

  return (
    <Page
      category={CalculatorsListRoutePath.subtitle}
      title={CalculatorsListRoutePath.title}
      isLoading={
        isLoadingFlowVolumeEnabled ||
        isLoadingNetworkProrationEnabled ||
        isLoadingEquipmentEmissionsEnabled
      }
      breadcrumbs={breadcrumbs}
      activeTabKey={tab ?? (isFlowVolumeEnabled ? "volume" : "emissions")}
      onActiveTabKeyChange={(tab) => setSearchParams({ tab })}
    >
      {isFlowVolumeEnabled ? (
        <Tab
          title={toTitleCaseString(CalculatorsTab.volume, { intent: "ui" })}
          tabKey={CalculatorsTab.volume}
        >
          <CalculatorsVolumeTab />
        </Tab>
      ) : null}
      {isNetworkProrationEnabled ? (
        <Tab
          title={toTitleCaseString(CalculatorsTab.networks, { intent: "ui" })}
          tabKey={CalculatorsTab.networks}
        >
          <CalculatorsNetworkTab />
        </Tab>
      ) : null}
      {isEquipmentEmissionsEnabled ? (
        <Tab
          title={toTitleCaseString(CalculatorsTab.emissions, { intent: "ui" })}
          tabKey={CalculatorsTab.emissions}
        >
          <CalculatorsEmissionsTab />
        </Tab>
      ) : null}
    </Page>
  );
};
